
import { Skull, Zap, Ghost, Trophy, Star, AlertTriangle } from "lucide-react";

type NotificationType = "success" | "warning" | "achievement" | "level" | "weight" | "diet";

export const getIcon = (type: NotificationType) => {
  switch (type) {
    case "achievement":
      return <Trophy className="h-8 w-8 text-yellow-300" />;
    case "level":
      return <Star className="h-8 w-8 text-purple-300" />;
    case "warning":
      return <AlertTriangle className="h-8 w-8 text-red-300" />;
    case "weight":
      return <Zap className="h-8 w-8 text-blue-300" />;
    case "diet":
      return <Skull className="h-8 w-8 text-green-300" />;
    default:
      return <Ghost className="h-8 w-8 text-gray-300" />;
  }
};
